import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadProduct,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";
import {
    AddPropertiesExpandParameter,
    ParseReplacementProductData as ParseReplacementData,
} from "@sonic/Handlers/Utilities";

export type HandlerType = Parameters<typeof DispatchCompleteLoadProduct>[0];

addToChainAfter(chain, PopulateApiParameter, AddPropertiesToExpand);

function AddPropertiesToExpand(props: HandlerType) {
    AddPropertiesExpandParameter(props.apiParameter);
}

addToChainBefore(chain, DispatchCompleteLoadProduct, ParseReplacementProductData);

function ParseReplacementProductData(props: HandlerType) {
    if (props.apiResult) {
        ParseReplacementData(props.apiResult);
    }
}
